import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_FUNCTION} from '../../metamodel/Concept';

export default class ApplicationFunctionNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_FUNCTION;
	}
}
